import { useDashboardWorkspaceContext } from '~/app/(dashboard)/dashboardContext'
import { MemberAvatar } from '../MemberAvatar'
import fallbackAvatar from '../../../public/logo192.png'

export const AccountAvatar = () => {
  const { userProfile, memberId } = useDashboardWorkspaceContext()
  return (
    <MemberAvatar
      name={userProfile?.fullName ?? ''}
      email={userProfile?.email ?? ''}
      avatar={userProfile?.avatar ?? fallbackAvatar.src}
      memberId={memberId}
      imageClassName="bg-gray-500"
    />
  )
}
